import PageNotFound from '@/components/elements/PageNotFound/PageNotFound'

const SheetMembranes = () => {
  return (
    <PageNotFound/>
  )
}

export default SheetMembranes